import { connect } from 'react-redux';
import {
    Row,
    Col,
    Label
} from 'reactstrap';
import {
    INTERNATIONAL_DATE_FORMAT,
    EMPTY_LIST
} from 'src/common/constants';

import {
    API_URL_REPORT_DOWNLOAD_USER_ATTACHMENTS
} from '../../../constants';

import { 
    REPORT_STATUS_LIST 
} from '../../../../../components/constants';
import { map } from 'rxjs/operators';
import AnonymouslyIcon from '../../../../../assets/images/report_anonymously.svg';
import ConfidentialyIcon from '../../../../../assets/images/report_confidently.svg';
import OtherRequestsIcon from "src/modules/data-protection/assets/images/OtherRequests.png";
import MeetingIcon from '../../../../../assets/images/arrange_meeting.svg';
import DateUtils from '../../../../../services/utils/DateUtils';
import Request from '../../../../../services/Request';
import { withNamespaces } from 'react-i18next';

const ReportTypes = {
    'data breach incident': {
        title: 'Data Breach Incident',
        image: AnonymouslyIcon
    },
    'data subject request': {
        title: 'Data Subject Request',
        image: OtherRequestsIcon
    },
    'data deletion request': {
        title: 'Data Deletion Request',
        image: ConfidentialyIcon
    },
    'processing activity': {
        title: 'Processing Activity',
        image: MeetingIcon
    }
}

const ReportFields = ({
    t,
    token,
    isLoading,
    isThirdParty,
    isEmployee,
    report
}) => {

    const dateUtils = new DateUtils();

    const renderReportType = () => {
        if(isLoading || !report) {
            return (
                <p className='dt-field dt-skeleton' />
            )
        }

        const reportType = ReportTypes[report.questionnaire?.toLowerCase()]

        return (
            <p className='dt-field'>
                <img
                    style={{ width: '20px', height: '20px', marginRight: 9 }}
                    alt={reportType?.title}
                    className='rounded-circle card-img'
                    src={reportType?.image}
                />
                <span   
                    style={{ textTransform: 'capitalize' }}
                >
                    {t(reportType?.title)}
                </span>
            </p>
        )
    }

    const renderReportStatus = () => {
		const currentStatus = REPORT_STATUS_LIST.find((i) => i.id === report?.status);

        return (
            <Col sm='12' md='6'>
				<div className='mb-3'>
					<Label className='form-label text-dark'>
                        {t('Status')}:
                    </Label>
                    {isLoading || !currentStatus ? (
                        <>
							<p className='dt-field dt-skeleton'></p>
							<p className='dt-field dt-skeleton dt-update-date'></p>
						</>
                    ) : (
                        <>
                            <div 
                                className={currentStatus.className}
                                >
                                    {t(currentStatus.titleKey)}
                                </div>
                            <br />
                            <small className='text-muted'>
                                {t('Status Updated')}
                                <span className='text-info'>
                                    {dateUtils.convertTimeStampToDate(
                                        report.status_updating_date, 
                                        INTERNATIONAL_DATE_FORMAT
                                    )}
                                </span>
                            </small>
                        </>
                    )}
				</div>
			</Col>
        )
	};

    const renderAttachmentsList = (attachments) => {
        if(!attachments.length) {
            return (
                <p>{t(EMPTY_LIST)}</p>
            )
        }

        return (
            <ul
                className='list-unstyled categories-list mb-0'
                style={{
                    fontSize: '12px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '8px',
                }}
            >
                {attachments.map((attachment) => {
                    if (!attachment.is_internal)
                        return (
                            <li key={attachment.id}>
                                <span
                                    className='bg-warning me-1 badge badge-secondary'
                                    style={{
                                        display: 'inline-block',
                                        lineHeight: '20px',
                                        padding: '0 10px 1px 10px',
                                        fontSize: '10px',
                                        fontWeight: 'bold',
                                    }}
                                >
                                    {attachment.type}
                                </span>
                                {attachment.name}
                            </li>
                        );
                    return null;
                })}
            </ul>
        );
	};

    const downloadAttachments = async () => {
        const request = new Request();
		request.downloadZip(
            API_URL_REPORT_DOWNLOAD_USER_ATTACHMENTS,
            'POST',
            {
                report_case_id: report.case_id,
            },
            token,
            {
                responseType: 'arraybuffer'
            }
		).pipe(
            map((response) => {
                return response;
            })
        ).subscribe((response) => {});
	};

    const renderAttachments = () => {
        if(isLoading) {
            return (
                <div className='dt-field dt-skeleton dt-accordion' />
            )
        }

        const attachments = report?.attachments || [];
        
		return (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div
                    style={{
                        borderRadius: '6px 6px 0 0',
                        padding: '5px 10px',
                        lineHeight: '35px',
                        color: '#ffffff',
                        fontWeight: 'bold',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                    }}
                    className='bg-primary'
                >
                    {t('All attachments')}

                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row-reverse',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        {/* download button */}
                        {attachments.length > 0 && !isThirdParty ? (
                            <span
                                onClick={downloadAttachments}
                                style={{
                                    width: '30px',
                                    height: '30px',
                                    background: '#ffffff',
                                    marginLeft: '10px',
                                    borderRadius: '0.25rem',
                                    color: '#505d69',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    border: '1px solid #ced4da',
                                    cursor: 'pointer',
                                }}
                                className='float-end'
                            >
                                <i className='fa fa-download'></i>
                            </span>
                        ) : null}
                    </div>
                </div>
                <div
                    style={{
                        border: '1px solid #dadada',
                        borderTop: 'none',
                        padding: '10px',
                        borderRadius: '0 0 6px 6px',
                    }}
                >
                    <div
                        style={{
                            maxHeight: '200px',
                            overflow: 'auto',
                        }}
                    >
                        {renderAttachmentsList(attachments)}
                    </div>
                </div>
            </div>
		);
	};

    return (
        <Row>
            <Col sm='12' lg='7'>
                <Row>
                    <Col sm='12' md='6'>
                        <div className='mb-3'>
                            <Label className='form-label text-dark'>
                                {t('Type')}:
                            </Label>
                            {renderReportType()}
                        </div>
                    </Col>

                    {/* channel */}
                    <Col sm='12' md='6'>
                        <div className='mb-3'>
                            <Label className='form-label text-dark'>
                                {t('Channel')}:
                            </Label>
                            {isLoading ? (
                                <p className='dt-field dt-skeleton' />
                            ) : (
                                <p className='dt-field'>
                                    <span className='badge bg-primary'>{t("web")}</span>
                                </p>
                            )}
                        </div>
                    </Col>
                </Row>

                <Row>
                    {/* submission date */}
                    <Col sm='12' md='6'>
                        <div className='mb-3'>
                            <Label className='form-label text-dark'>
                                {t('Submission date')}:
                            </Label>
                            {isLoading ? (
                                <p className='dt-field dt-skeleton' />
                            ) : (
                                <p className='dt-field'>
                                    {dateUtils.convertTimeStampToDate(
                                        report.submission_date, INTERNATIONAL_DATE_FORMAT
                                    )}
                                </p>
                            )}
                        </div>
                    </Col>

                    {/* closing date */}
                    <Col sm='12' md='6'>
                        <div className='mb-3'>
                            <Label className='form-label text-dark'>
                                {t('Closing date')}:
                            </Label>
                            {isLoading ? (
                                <p className='dt-field dt-skeleton' />
                            ) : (
                                <p className='dt-field'>
                                    {dateUtils.convertTimeStampToDate(
                                        report.closing_date, INTERNATIONAL_DATE_FORMAT
                                    )}
                                </p>
                            )}
                        </div>
                    </Col>
                </Row>

                <Row>
                    {/* assigned analyst */}
                    {!report?.is_deleted_content ? (
                        <Col sm='12' md='6'>
                            <div className='mb-3'>
                                <Label className='form-label text-dark'>
                                    {t('Assigned analyst')}
                                </Label>

                                {!isLoading ? (
                                    <p>
                                        {report.analyst_assigned ? report.analyst_assigned.label : ''}
                                    </p>
                                ) : (
                                    <p className='dt-field dt-skeleton'></p>
                                )}
                            </div>
                        </Col>
                    ) : null}

                    {renderReportStatus()}
                </Row>
            </Col>

            {!isLoading ? (
                <Col sm='12' lg='5'>
                    {report?.is_deleted_content ? (
                        <Row>
                            {/* reason for deletion */}
                            {report.reason_for_deletion ? (
                                <Col sm='12'>
                                    <div className='mb-3'>
                                        <Label 
                                            className='form-label mb-0 text-dark'>
                                                {t('Reason for Deletion')}:
                                            </Label>
                                        <p>
                                            {report.reason_for_deletion === 'CASE_GREATER_THAN_5_YEARS_CLOSED'
                                                ? t('Case >= 5 years closed')
                                                : report.reason_for_deletion === 'CASE_GREATER_THAN_10_YEARS_CLOSED'
                                                    ? t('Case >= 10 years closed')
                                                    : report.reason_for_deletion}
                                        </p>
                                    </div>
                                </Col>
                            ) : null}

                            {/* status updating date */}
                            {report.status_updating_date ? (
                                <Col sm='12'>
                                    <div className='mb-3'>
                                        <Label className='form-label mb-0 text-dark'>
                                            {t('Deletion date')}:
                                        </Label>
                                        <p>
                                            {dateUtils.convertTimeStampToDate(
                                                report.status_updating_date, 
                                                INTERNATIONAL_DATE_FORMAT
                                            )}
                                        </p>
                                    </div>
                                </Col>
                            ) : null}

                            {/* assigned analyst */}
                            {report.analyst_assigned ? (
                                <Col sm='12'>
                                    <div className='mb-3'>
                                        <Label 
                                            className='form-label mb-0 text-dark'
                                        >
                                            {t('Approver')}:
                                        </Label>
                                        <p>
                                            {report.deleted_by_name}
                                        </p>
                                    </div>
                                </Col>
                            ) : null}
                        </Row>
                    ) : (
                        <Row>
                            {/* attachments */}
                            <Col sm='12' md='12' lg='12'>
                                {renderAttachments()}
                            </Col>
                        </Row>
                    )}
                </Col>
            ) : (
                <Col sm='12' lg='5'>
                    <Row>
                        <Col>
                            <div style={{ height: '4rem' }}></div>
                            <div className='dt-field dt-skeleton dt-accordion'></div>
                        </Col>

                        <Col>
                            <div style={{ height: '4rem' }}></div>
                            <div className='dt-field dt-skeleton dt-accordion'></div>
                        </Col>
                    </Row>
                </Col>
            )}
        </Row>
    )
}

const mapStatetoProps = (state) => {
    const { token } = state.Login;
    return {
        token
    };
};

export default withNamespaces()(
    connect(mapStatetoProps)(
        ReportFields
    )
);
